import React from "react";
import classname from "classnames";

import { ArticleListCategoryItem } from "../types";

interface Props {
  item: ArticleListCategoryItem;
  activeQuery: string;
  categoryRoot: string;
  onClickCategory: (categorySlug: string, categoryRoot: string) => void;
}

const CategoryFilter: React.FC<Props> = ({ item, activeQuery, categoryRoot, onClickCategory }) => {
  const classes = classname(
    "cursor-pointer rounded-lg px-3 py-1 text-2xs font-semibold hover:text-red-corporate hover:underline",
    {
      "bg-light shadow-tab": activeQuery === item.slug,
    }
  );

  return (
    <li>
      <button className={classes} onClick={() => onClickCategory(item.slug, categoryRoot)} type="button">
        {item.title}
      </button>
    </li>
  );
};

export default CategoryFilter;
